<div class="main">
    <app-header-section></app-header-section>
    <app-breadcrumb-author></app-breadcrumb-author>
    <app-author-section></app-author-section>
    <app-footer-section></app-footer-section>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
    <app-scrollup></app-scrollup>
</div>
